import gql from 'graphql-tag'

export default gql`
mutation updateProductList($id: ID!, $fields: ProductListReqFields!) {
	cashAssist {
		updateProductList(id: $id, fields: $fields) {
			id
			name
		}
	}
}
`
